import(/* webpackMode: "eager" */ "/app/src/app/register/page.tsx");
